import { devicelist, health } from '@/api/activity'
import { useUserStore } from '@/stores/user'
import { isNewUiVersion } from '@/utils/uiVersion'

/** 本会话是否已按绑定状态完成入口落地（避免点「健康」Tab 被反复踢回监测） */
export const LANDING_BY_BINDING_KEY = 'landingByBindingDone'

/**
 * 清除入口落地标记（登录前调用）
 * @returns {void}
 */
export function clearLandingByBindingFlag() {
  try {
    sessionStorage.removeItem(LANDING_BY_BINDING_KEY)
  } catch (e) {
    /* ignore */
  }
}

/**
 * 标记本会话已完成入口落地
 * @returns {void}
 */
export function markLandingByBindingDone() {
  try {
    sessionStorage.setItem(LANDING_BY_BINDING_KEY, '1')
  } catch (e) {
    /* ignore */
  }
}

/**
 * 本会话是否已完成入口落地
 * @returns {boolean}
 */
export function hasLandingByBindingDone() {
  try {
    return sessionStorage.getItem(LANDING_BY_BINDING_KEY) === '1'
  } catch (e) {
    return false
  }
}

/**
 * 是否已填写用户名（个人资料 name）
 * - 优先读本地 userInfo
 * - 再请求 /user/v1/health 确认
 * - 接口异常时不拦截进入，避免异常导致无法进首页
 * @returns {Promise<boolean>}
 */
export async function hasUserDisplayName() {
  const userStore = useUserStore()
  const localName =
    (userStore.userInfo && (userStore.userInfo.name || userStore.userInfo.userName)) || ''
  if (String(localName).trim()) return true

  try {
    const res = await health()
    const ok = res && (res.code === '1000' || res.code === 1000)
    if (!ok) return true
    if (!res.data) return false
    const name = res.data.name != null ? String(res.data.name).trim() : ''
    if (name) {
      userStore.setUserInfo({
        ...(userStore.userInfo || {}),
        name
      })
      return true
    }
    return false
  } catch (e) {
    return true
  }
}

/**
 * 查询手表是否已绑定（bindStatus === '02'），并同步到 userInfo.isBinding
 * @returns {Promise<boolean>}
 */
export async function syncWatchBindingStatus() {
  const userStore = useUserStore()
  let isBinding = false
  try {
    const res = await devicelist()
    if (res && (res.code === '1000' || res.code === 1000)) {
      const data = res.data
      isBinding = Array.isArray(data) && data.some((item) => item && item.bindStatus === '02')
    }
  } catch (e) {
    /* ignore */
  }
  userStore.setUserInfo({
    ...(userStore.userInfo || {}),
    isBinding
  })
  return isBinding
}

/**
 * 解析新版进入 App 的落地页
 * - 无用户名 → 健康测评分步填写页
 * - 已绑定手表 → 底部「监测」页
 * - 未绑定 → 首页「健康」页
 * @returns {Promise<{ name: string, query?: Object }>}
 */
export async function resolveLandingLocation() {
  const hasName = await hasUserDisplayName()
  if (!hasName) {
    return { name: 'healthAssessFlow' }
  }
  if (!isNewUiVersion()) {
    return { name: 'healthHomePage' }
  }
  const isBinding = await syncWatchBindingStatus()
  if (isBinding) {
    return { name: 'healthMonitoringDashboard' }
  }
  return { name: 'healthAiHome', query: { tab: 'health' } }
}



// WEBPACK FOOTER //
// ./src/utils/landingRoute.js